import { render, staticRenderFns } from "./newsLetterList.vue?vue&type=template&id=4d0ab0b2"
import script from "./newsLetterList.vue?vue&type=script&lang=js"
export * from "./newsLetterList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports